/**
 * Note: More info -> Bobi & Kalin
 * dev => Shelly Cloud DEV skill -> deep dev skill available only for Allterco Developer Accounts in Alexa (Mitko, Bobi & Kalin)
 * test_prod +> Shelly Skill in development stage, also vailable only for developer account in Amazon Alexa (Mitko, Bobi, Kalin)
 * prod => Shelly Skill -> published skill version ("live" stage in Amazon)
 * required string in PHP requests to know what skill and in what stage processing
 */
export const ALEXA_SKILLS_STAGES = {
	deep_dev: 'dev', // deep dev skill
	official_dev: 'test_prod', //official in development
	official_live: 'prod', // official for users
};

export const ALEXA_QUERY_STAGE_NAMES = {
	test_prod: 'dev',
	prod: 'prod',
	dev: 'deep_dev',
};

export const map_alexa_stage_from_uri = (_loc_str: string = '') => {
	let _split_path = _loc_str.split('/app-to-app-alexa'); //main part; for prod returns ["", ""]; dev => ['',"-dev"]; test_prod => ["", "-developemnt"];
	if (_split_path.length === 2) {
		switch (_split_path[1]) {
			case '-dev':
				//comes from /app-to-app-alexa-dev => Shelly Cloud DEV skill -> deep dev
				return ALEXA_SKILLS_STAGES.deep_dev;
			case '-developement':
				//comes from "/app-to-app-alexa-development"=> prod skill in dev ver
				return ALEXA_SKILLS_STAGES.official_dev;
			default:
				//main pathname for official published skill /app-to-app-alexa
				// also the only one handled by iOS and Android, when Alexa redirect to our app
				return ALEXA_SKILLS_STAGES.official_live;
		}
	}
};
